export interface IAction<T = any> {
  type: symbol
  payload?: T
}

interface IEmitActionObject<T = any> {
  set: symbol
  emit: (payload: T) => IAction<T>
}

export interface INetwork {
  rpcUrl?: string
  networkId?: number
  ledgerPath?: string
}

export const toggleModalType: IEmitActionObject<boolean> = {
  set: Symbol('SET_WALLET_MODAL'),
  emit(payload) {
    return { type: this.set, payload };
  },
};

export const toggleLedgerModalType: IEmitActionObject = {
  set: Symbol('SET_LEDGER_MODAL'),
  emit(payload) {
    return { type: this.set, payload };
  },
};

export const toggleTrezorModalType: IEmitActionObject = {
  set: Symbol('SET_TREZOR_MODAL'),
  emit(payload) {
    return { type: this.set, payload };
  },
};

export const disconnectWalletType: IEmitActionObject = {
  set: Symbol('DISCONNECT_WALLET'),
  emit(payload) {
    return { type: this.set, payload };
  },
};

export const setNetworkType: IEmitActionObject<INetwork> = {
  set: Symbol('SET_NETWORK'),
  emit(payload) {
    return { type: this.set, payload };
  },
};

export const connectWalletType = {
  request: Symbol('CONNECT_WALLET_REQUEST'),
  success: Symbol('CONNECT_WALLET_SUCCESS'),
  failed: Symbol('CONNECT_WALLET_FAILED'),
};

export const getBaseTokenBalanceType = {
  request: Symbol('GET_BALANCE_REQUEST'),
  success: Symbol('GET_BALANCE_SUCCESS'),
  failed: Symbol('GET_BALANCE_FAILED'),
};
